/* PC Frequently Bought Together - see snippets/pc-fbt.liquid
   Rows are companion products only (never the product being viewed). */
(function () {
  'use strict';

  var MAX_ROWS = 4;

  function group(intStr, sep) {
    var out = '', c = 0;
    for (var i = intStr.length - 1; i >= 0; i--) {
      out = intStr.charAt(i) + out; c++;
      if (c % 3 === 0 && i > 0) out = sep + out;
    }
    return out;
  }

  /* Shopify money_format. Paramount's is wrapped in HTML (<span class=money>Rs. {{amount}}</span>),
     so tags are stripped first - prices are written with textContent. */
  function fmt(cents, format) {
    format = String(format || '{{amount}}').replace(/<[^>]*>/g, '');
    cents = Number(cents) || 0;
    var s = format.indexOf('{{'), e = format.indexOf('}}');
    var key = (s > -1 && e > s) ? format.slice(s + 2, e).trim() : 'amount';
    var prec = 2, th = ',', dec = '.';
    if (key === 'amount_no_decimals') { prec = 0; }
    else if (key === 'amount_with_comma_separator') { th = '.'; dec = ','; }
    else if (key === 'amount_no_decimals_with_comma_separator') { prec = 0; th = '.'; dec = ','; }
    else if (key === 'amount_with_apostrophe_separator') { th = String.fromCharCode(39); }
    var parts = (cents / 100).toFixed(prec).split('.');
    var v = group(parts[0], th) + (parts[1] ? dec + parts[1] : '');
    return ((s > -1 && e > s) ? format.slice(0, s) + v + format.slice(e + 2) : v).trim();
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .split('&').join('&amp;').split('<').join('&lt;')
      .split('>').join('&gt;').split('"').join('&quot;');
  }

  /* Label a variant with only the options that differ across the product (usually size) */
  function shortLabel(p, v) {
    var vars = p.variants || [], parts = [];
    for (var k = 1; k <= 3; k++) {
      var key = 'option' + k, seen = {}, n = 0;
      for (var i = 0; i < vars.length; i++) {
        var val = vars[i][key];
        if (val != null && !seen[val]) { seen[val] = true; n++; }
      }
      if (n > 1 && v[key] != null) parts.push(v[key]);
    }
    return parts.length ? parts.join(' / ') : v.title;
  }

  /* Button label: "Add 4 items to cart" (CSS uppercases it) */
  function btnLabel(n) {
    return 'Add ' + n + (n === 1 ? ' item' : ' items') + ' to cart';
  }

  function init(root) {
    if (root.__pcFbt) return;
    root.__pcFbt = true;

    var money = root.getAttribute('data-money-format') || '{{amount}}';
    var productId = String(root.getAttribute('data-product-id'));
    var companions = root.querySelector('[data-fbt-companions]');
    var totalEl = root.querySelector('[data-fbt-total]');
    var btn = root.querySelector('[data-fbt-add]');
    var msg = root.querySelector('[data-fbt-msg]');
    var busy = false;

    function rows() { return root.querySelectorAll('[data-fbt-row]'); }
    function variantEl(row) { return row.querySelector('[data-fbt-variant]'); }
    function priceOf(row) {
      var el = variantEl(row);
      if (!el) return 0;
      if (el.tagName === 'SELECT') {
        var o = el.options[el.selectedIndex];
        return o ? Number(o.getAttribute('data-price')) : 0;
      }
      return Number(el.getAttribute('data-price'));
    }

    function update() {
      var all = rows(), total = 0, n = 0;
      for (var i = 0; i < all.length; i++) {
        var r = all[i], p = priceOf(r);
        var pe = r.querySelector('[data-fbt-price]');
        if (pe) pe.textContent = fmt(p, money);
        var cb = r.querySelector('[data-fbt-check]');
        var on = cb ? cb.checked : true;
        r.classList.toggle('is-off', !on);
        if (on) { total += p; n++; }
      }
      totalEl.textContent = fmt(total, money);
      if (!busy) {
        btn.disabled = n === 0;
        btn.textContent = btnLabel(n);
      }
      root.hidden = all.length < 1;
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-fbt-check], [data-fbt-variant]')) update();
    });

    /* Swap in Shopify recommendations if the API returns any */
    function rowHtml(p) {
      var vars = p.variants || [];
      var first = null;
      for (var i = 0; i < vars.length; i++) { if (vars[i].available) { first = vars[i]; break; } }
      if (!first) return '';
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      var picker;
      if (vars.length === 1) {
        picker = '<input type="hidden" data-fbt-variant value="' + first.id + '" data-price="' + first.price + '">';
      } else {
        picker = '<select class="pc-fbt__select" data-fbt-variant aria-label="Option for ' + esc(p.title) + '">';
        for (var j = 0; j < vars.length; j++) {
          var v = vars[j];
          picker += '<option value="' + v.id + '" data-price="' + v.price + '"' +
            (v.available ? '' : ' disabled') + (v.id === first.id ? ' selected' : '') + '>' +
            esc(shortLabel(p, v)) + (v.available ? '' : ' - Sold out') + '</option>';
        }
        picker += '</select>';
      }
      return '<div class="pc-fbt__row" data-fbt-row>' +
        '<input type="checkbox" class="pc-fbt__check" data-fbt-check checked aria-label="Include ' + esc(p.title) + '">' +
        '<a class="pc-fbt__img" href="' + esc(p.url) + '" tabindex="-1">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="80" height="107" loading="lazy">' : '') +
        '</a>' +
        '<div class="pc-fbt__info">' +
          '<a class="pc-fbt__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="pc-fbt__meta">' + picker + '<span class="pc-fbt__price" data-fbt-price></span></div>' +
        '</div></div>';
    }

    function loadRecos(intent) {
      var base = root.getAttribute('data-reco-url');
      if (!base) return Promise.resolve([]);
      var url = base + '.json?product_id=' + encodeURIComponent(productId) + '&limit=8&intent=' + intent;
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) {
          /* Never include the product being viewed */
          return (d.products || []).filter(function (p) {
            return p.available && String(p.id) !== productId;
          }).slice(0, MAX_ROWS);
        })
        .catch(function () { return []; });
    }

    loadRecos('complementary')
      .then(function (list) { return list.length ? list : loadRecos('related'); })
      .then(function (list) {
        var html = list.map(rowHtml).join('');
        if (!html) return;
        companions.innerHTML = html;
        update();
      });

    /* Add selected items in one request */
    function drawerIsOpen() {
      var h = document.documentElement.className + ' ' + document.body.className;
      return h.indexOf('js-drawer-open') > -1;
    }

    function afterAdd() {
      var s = window.theme && window.theme.settings;
      var cartUrl = root.getAttribute('data-cart-url') || '/cart';
      if ((s && s.cartType === 'page') || !document.getElementById('CartDrawer')) {
        window.location.href = cartUrl;
        return;
      }
      ['cart:build', 'cart:refresh'].forEach(function (n) {
        document.dispatchEvent(new CustomEvent(n, { bubbles: true }));
      });
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      }, 250);
      setTimeout(function () {
        if (!drawerIsOpen()) {
          msg.classList.add('is-ok');
          msg.innerHTML = 'Added to your cart. <a href="' + esc(cartUrl) + '">View cart</a>';
        }
      }, 1200);
    }

    btn.addEventListener('click', function () {
      var items = [], all = rows();
      for (var i = 0; i < all.length; i++) {
        var cb = all[i].querySelector('[data-fbt-check]');
        var ve = variantEl(all[i]);
        if (cb && cb.checked && ve && ve.value) items.push({ id: Number(ve.value), quantity: 1 });
      }
      if (!items.length) return;

      busy = true;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      msg.classList.remove('is-ok');
      msg.textContent = '';

      fetch(root.getAttribute('data-cart-add-url') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (j) { if (!r.ok) throw j; return j; });
        })
        .then(function () {
          btn.textContent = 'Added';
          afterAdd();
          setTimeout(function () { busy = false; update(); }, 1800);
        })
        .catch(function (err) {
          busy = false;
          msg.textContent = (err && (err.description || err.message)) || 'Could not add these items. Please try again.';
          update();
        });
    });

    update();
  }

  function boot() {
    var els = document.querySelectorAll('[data-pc-fbt]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
